// The real authenticated shell — replaces App.tsx's throwaway MockupShell
// (plan §2.2). Composes BrandBar → CaseStripSlot → TabBar → ActivePane →
// FooterSlot. The 380px taskpane container + Tailwind chrome.
//
// F-SHELL ships this fully demoable with ZERO features registered: the TabBar
// renders the 5 KNOWN_TABS, ActivePane shows <ComingSoon> for each. Wave-1
// features swap their ComingSoon for a real Pane via the registry seam — with
// ZERO edits to this file (the §8 contract).

import { BrandBar } from './BrandBar'
import { CaseStripSlot } from './CaseStripSlot'
import { TabBar } from './TabBar'
import { ActivePane } from './ActivePane'

// Footer slot — empty placeholder in F-SHELL (a feature / F-CASE may fill it).
// Kept as a named local so the layout slot is explicit + greppable.
function FooterSlot(): JSX.Element {
  return <div data-testid="shell-footer" className="border-t border-ink/10" />
}

export function Shell(): JSX.Element {
  return (
    <div
      data-testid="shell"
      className="mx-auto flex min-h-screen w-[380px] flex-col bg-white"
    >
      <BrandBar />
      <CaseStripSlot />
      <TabBar />
      <div className="flex flex-1 flex-col overflow-y-auto">
        <ActivePane />
      </div>
      <FooterSlot />
    </div>
  )
}
